module.exports = __webpack_public_path__ + "static/media/security.e3e08a18.svg";